.root {
  width: 100%;
  margin-bottom: 1.5rem;
}

.insightText {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  u {
    text-decoration: none;
  }
}

.insightBadge {
  margin-right: 10px;
}
